"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeIcon = exports.Icon = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
exports.Icon = styled_components_1.default.svg.attrs({
    version: '1.1',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var Svg = (0, styled_components_1.default)(exports.Icon)(templateObject_2 || (templateObject_2 = __makeTemplateObject([" \n  width: ", ";\n  height: ", ";\n  color: ", ";\n"], [" \n  width: ", ";\n  height: ", ";\n  color: ", ";\n"])), function (props) { return typeof props.size === 'number' ? props.size + 'px' : props.size; }, function (props) { return typeof props.size === 'number' ? props.size + 'px' : props.size; }, function (props) { return props.color; });
var makeIcon = function (_a) {
    var Path = _a.Path, name = _a.name, _b = _a.defaultColors, defaultColors = _b === void 0 ? [] : _b, _c = _a.width, width = _c === void 0 ? '16' : _c, _d = _a.height, height = _d === void 0 ? '16' : _d, _e = _a.viewBox, viewBox = _e === void 0 ? '0 0 16 16' : _e, _f = _a.allPathData, allPathData = _f === void 0 ? [] : _f, colorful = _a.colorful;
    var IconComponent = function (props) {
        var _a = props.size, size = _a === void 0 ? 16 : _a, _b = props.color, color = _b === void 0 ? defaultColors : _b, className = props.className, currentColor = props.currentColor, _c = props.showTitle, showTitle = _c === void 0 ? false : _c, onClick = props.onClick;
        // const iconType = name.split('_').slice(-1)[0];
        var pathColors = [color].flat();
        if (currentColor) {
            pathColors = Array(defaultColors.length).fill('currentColor');
        }
        if (pathColors.length < defaultColors.length) {
            pathColors.splice.apply(pathColors, __spreadArray([pathColors.length, 0], __read(defaultColors.slice(pathColors.length)), false));
        }
        if (colorful) {
            return react_1.default.createElement(Svg, { width: width, height: height, viewBox: viewBox, className: className, size: size, fill: "none", onClick: onClick },
                showTitle && react_1.default.createElement("title", null, name),
                react_1.default.createElement(Path, { colors: pathColors }));
        }
        return react_1.default.createElement(Svg, { width: width, height: height, viewBox: viewBox, className: className, size: size, fill: pathColors[0], onClick: onClick },
            showTitle && react_1.default.createElement("title", null, name),
            react_1.default.createElement(Path, { colors: ['inherit'] }));
    };
    IconComponent.toString = function () {
        return allPathData.join('\n');
    };
    return IconComponent;
};
exports.makeIcon = makeIcon;
var templateObject_1, templateObject_2;
